import { render, staticRenderFns } from "./MenuItemGroup.vue?vue&type=template&id=2083d35e"
import script from "./MenuItemGroup.vue?vue&type=script&lang=js"
export * from "./MenuItemGroup.vue?vue&type=script&lang=js"
import style0 from "./MenuItemGroup.vue?vue&type=style&index=0&id=2083d35e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports